<div class="root">
  <div
    id="alert-success"
    class="alert alert-success"
    data-testid="shared.alert.success-message"
  ></div>
  <div
    id="alert-danger"
    class="alert alert-danger"
    data-testid="shared.alert.error-message"
  ></div>
</div>
